class Element {
	setAlias (alias) {
		this.alias = alias
		return this
	}

	setNode (param) {
		if (param instanceof HTMLElement) this.node = param
		if (typeof param === 'string') this.node = document.querySelector(param)

		if (!this.node) console.warn(`Can't found node`, param)

		this.constantStyles = {}
		for (let i = 0; i < this.node.style.length; i++) this.constantStyles[this.node.style[i]] = true

		return this
	}

	setConfig ({ displayAlways = false }) {
		this.displayAlways = displayAlways

		return this
	}

	setStyles (styles) {
		const nStyle = this.node.style
		for (let i = 0; i < nStyle.length; i++) {
			const name = nStyle[i]
			if (!styles[name] && !this.constantStyles[name]) nStyle.removeProperty(name)
		}
		Object.keys(styles).map(name => { nStyle[name] = styles[name] })

		return this
	}

	onProgressChange (progress, frame) {
		frame.resolvePluginsFor(this.alias, this.node, progress)
		let styles = frame.getStylesFor(this.alias, progress)

		if (styles === 'NO_PARAMS_FOR_ALIAS') styles = this.displayAlways ? {} : { display: 'none' }

		this.setStyles(styles)
	}
}
export { Element }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scrollAnimation/Element.js